import { Button, Grid, Tooltip } from "@material-ui/core";
import useOneOnOneScheduler from "../../../shared/hooks/useOneOnOneScheduler";
import { useStyle } from "./schedule-button.styles";

type Props = {
  tooltip?: string;
  disabled?: boolean;
  onClick(): void;
};

export default function ScheduleButton({ tooltip, disabled, onClick }: Props) {
  const classes = useStyle();
  const { message, isInvalid } = useOneOnOneScheduler();

  return (
    <Grid item container justifyContent="center" md={12}>
      <Tooltip
        title={tooltip || message}
        arrow
        placement="left"
        classes={{ tooltip: classes.tooltip, arrow: classes.arrowToolTip }}
      >
        <span>
          <Button
            onClick={onClick}
            disabled={disabled || isInvalid}
            className={classes.scheduleButton}
          >
            Schedule 1:1 Meeting
          </Button>
        </span>
      </Tooltip>
    </Grid>
  );
}
